module.exports = __webpack_public_path__ + "img/organization.bee04d8a.png";